import "./_imagesloaded.js";
import "./_slick.js";
import "./_sticky-kit.js";

jQuery(document).ready( function($) {

	var $html = $('html');


	/*************
	WHOLESALE
	*************/

	$('.wholesale-btn-open').on('click',function(e){
	    $('#wholesale').show();
	    $('.site-header__logo').addClass('active');
		$('#mobile-menu').hide();
		$('html').removeClass('nav-open');
	});
	$('.wholesale-btn-close').on('click',function(e){
	    $('#wholesale').hide();
	    $('.site-header__logo').removeClass('active');
	    $('#mobile-menu').show();
	});

	// Add placeholder text to login form
	$('#wholesale #gform_fields_login input[type=text]').attr( 'placeholder', 'Username' );
	$('#wholesale #gform_fields_login input[type=password]').attr( 'placeholder', 'Password' );

	/*************
	NAVIGATION
	*************/

	$('.toggle-mobile-menu').on('click', function(e){
		e.preventDefault();

		$('html').toggleClass('nav-open');
	});


	/*************
	IMAGES
	*************/

	$('p > img').unwrap();




	/*************
	WOOCOMMERCE
	*************/

	$(document).on('click', '.plus', function(e){
		var val = parseInt($(this).prev('input').val());
		console.log(val);
	    $(this).prev('input').val( val+1 );
	    $('button[name=update_cart]').removeAttr("disabled");
	});
	$(document).on('click', '.minus', function(e){
		var val = parseInt($(this).next('input').val());
		console.log(val);
	    $(this).next('input').val( val-1 );
	    $('button[name=update_cart]').removeAttr("disabled");
	});



	$('.specs p').on('click',function(e){
	    $(this).parent().toggleClass('active');
	});


	/*************
	STICKY IMAGES
	*************/

    var windowWidth = $(window).width();



	// home
	function homeScrollEffect() {
		var windowWidth = window.innerWidth;

		if( windowWidth >= 960 ) {
			$('.img-1').stick_in_parent();
		} else {
			$('.img-1').trigger("sticky_kit:detach");
		}
	}
	homeScrollEffect();


	// products
	function productScrollEffect() {
		var windowWidth = window.innerWidth;

		if( windowWidth >= 960 ) {
			$('[data-sticky="column"]').stick_in_parent({
				parent: '[data-sticky="parent"]',
				offset_top: 50
			});
		} else {
			$('[data-sticky="column"]').trigger("sticky_kit:detach");
		}
	}

    $('.product-main .thumbnails').imagesLoaded( function() {
		productScrollEffect();
	});


	/*************
    SLICK SLIDER
	*************/

    $('.home-slider').slick({
		dots: true,
		arrows: true,
		fade: true,
		nextArrow: '<div class="arrow arrow-next"></div>',
		prevArrow: '<div class="arrow arrow-prev"></div>',
		appendArrows: '.arrows',
	});
	$('.home-banner-slider').slick({
		autoplay: true,
		autoplaySpeed: 5000,
		dots: true,
		arrows: false,
		fade: true,
	});
	$('.story-slider').slick({
		dots: true,
		arrows: true,
		fade: true,
		nextArrow: '<div class="arrow arrow-next"></div>',
		prevArrow: '<div class="arrow arrow-prev"></div>',
		appendArrows: '.arrows',
	});
	$('.collection-slider').slick({
		dots: false,
		arrows: true,
		slidesToShow: 3,
  	slidesToScroll: 1,
		prevArrow: '<button type="button" class="slick-prev" aria-label="Previous">Previous</button>',
		nextArrow: '<button type="button" class="slick-next" aria-label="Next">Next</button>',
		responsive: [
			{
				breakpoint: 960,
				settings: {
					slidesToShow: 2,
					arrows: false
				}
			},
			{
				breakpoint: 332,
				settings: {
					slidesToShow: 1,
					arrows: false
				}
			}
		]
	});

	/*************
    RESIZE FUNCTION
	*************/

    var widthScreen = $(window).width();
    var resizeTimer;

    // Resize funciton to build or destory slider
    $(window).resize(
        function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
				productScrollEffect();
				homeScrollEffect();
            }, 250);
        }
    );

});